(function ($) {
		window.fnames = new Array();
		window.ftypes = new Array();
		fnames[0] = 'EMAIL';
		ftypes[0] = 'email';
		fnames[1] = 'FNAME';
		ftypes[1] = 'text';
		fnames[2] = 'LNAME';
		ftypes[2] = 'text';
		fnames[3] = 'ADDRESS';
		ftypes[3] = 'address';
		fnames[4] = 'PHONE';
		ftypes[4] = 'phone';
		fnames[5] = 'MMERGE5';
		ftypes[5] = 'text';
		fnames[6] = 'CAN_EMAIL';
		ftypes[6] = 'radio';
		fnames[7] = 'MMERGE7';
		ftypes[7] = 'text';
		fnames[8] = 'MMERGE8';
		ftypes[8] = 'imageurl';
}(jQuery));
	
var $mcj = jQuery.noConflict(true);